import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Category from './pages/Category';
import ProductDetail from './pages/ProductDetail';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:category" element={<Category />} />
            <Route path="/product/:id" element={<ProductDetail />} />
          </Routes>
        </main>
        
        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="md:col-span-2">
                <h3 className="text-2xl font-bold mb-4">AudioRoom</h3>
                <p className="text-gray-300 mb-4">
                  Your trusted guide to discovering the best Hi-Fi products for your vinyl listening journey.
                </p>
                <p className="text-gray-400 text-sm">
                  Expert curation • Best prices • Trusted vendors
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Categories</h4>
                <ul className="space-y-2 text-gray-300">
                  <li><Link to="/category/bookshelf_speakers" className="hover:text-white transition-colors">Bookshelf Speakers</Link></li>
                  <li><Link to="/category/turntables" className="hover:text-white transition-colors">Turntables</Link></li>
                  <li><Link to="/category/amplifiers" className="hover:text-white transition-colors">Amplifiers</Link></li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Support</h4>
                <ul className="space-y-2 text-gray-300">
                  <li><button className="hover:text-white transition-colors">Help Center</button></li>
                  <li><button className="hover:text-white transition-colors">Contact Us</button></li>
                  <li><button className="hover:text-white transition-colors">About</button></li>
                </ul>
              </div>
            </div>
            
            <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
              <p>&copy; 2024 AudioRoom. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;